import React, { Component } from "react"

import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
    TextField,
} from "@material-ui/core"

import SelectDewarPanel from "./EditDialog/SelectDewarPanel"
import SelectUserPanel from "./EditDialog/SelectUserPanel"

import SelectUserDialog from "../../users/SelectUserDialog.js"
import SelectDewarDialog from "../../dewars/SelectDewarDialog.js"

/**
 * События элемента
 * 
 * @param props.dewar - редактируемая запись учёта сосудов Дьюара.
 * 
 * onEditClick(dewar, user) - запрос на изменение сосуда Дьюара.
 * onCancelClick() - запрос отмены.
 */

class EditDialog extends (Component) {

    constructor(props) {
        
        super(props)

        this.state = {
            dialog: undefined,
            user: this.props.dewar.user,
            // dewar: this.props.dewar.dewar,
            comment: this.props.dewar.comment,
            completion: this.props.dewar.completion,
        }

    }

    isReady() {
        if (!this.state.user) {
            return false
        }
        if (this.props.dewar.user.id !== this.state.user.id) {
            return true
        } 
        if (this.props.dewar.completion !== this.state.completion) {
            return true
        }
        if (this.props.dewar.comment !== this.state.comment) {
            return true;
        }
        return false
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog
            open = {true}
            fullWidth = {true}        
        >

            <DialogTitle>Добавить сосуд Дьюара</DialogTitle>

            <DialogContent style = {{display: "flex", gap: "10px", flexDirection: "column"}}>

                <SelectUserPanel 
                    selected={this.state.user}
                    onSelectButtonClick={() => {
                        this.setState({dialog: <SelectUserDialog 
                            onSelectUser={async (user)=>{
                                this.setState({
                                    user: user,
                                    dialog: undefined,
                                })
                            }}
                            onCancel={()=>{
                                this.setState({dialog: undefined})
                            }}
                        />})
                    }}
                />

                <TextField 
                    label="Комментарий"
                    value={this.state.comment}
                    variant="outlined"
                    onChange={e => {
                        e.stopPropagation()
                        this.setState({comment: e.target.value})
                    }}
                />
                
                <FormControlLabel 
                    control={<Checkbox 
                        onChange={(e) => {
                            e.stopPropagation()
                            this.setState({completion: this.state.completion ? 0 : 1})
                        }}
                        checked={this.state.completion === 0 ? false : true}
                    />}
                    label="Шоу завершено"                    
                />

            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.isReady()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onEditClick === "function") {
                            this.props.onEditClick({
                                user: this.state.user,
                                completion: this.state.completion,
                                comment: this.state.comment,
                            })
                        }
                    }}
                >Изменить</Button>

                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

            </DialogActions>

        </Dialog>

    }

}

export default EditDialog